export default {
  statusPublish: 'publish',
  statusHidden: 'hidden',
  periodNever: 'never',
  periodMonth: 'month',
  periodDay: 'day',
  periodWeek: 'week',
  periodYear: 'year',
  periodIntervalOne: '1',
  periodIntervalTwo: '2',
  typeStandard: 'standard',
  typeOrder: 'order',
  typeRecurringSubscription: 'recurringSubscription',
  typeLimitedSubscription: 'limitedSubscription',
  typeVariableStandard: 'variableStandard',
  typeVariableRecurringSubscription: 'variableRecurringSubscription',
  typeVariableLimitedSubscription: 'variableLimitedSubscription',
  periodIntervalLabel(periodInterval) {
    switch(periodInterval) {
      case this.periodIntervalOne:
        return Core.Definition.getDefinition('À tous les');
        break
      case this.periodIntervalTwo:
        return Core.Definition.getDefinition('Au 2');
        break
      default:
        return ''
        break
    }
  },
  periodIntervalOptions(keys) {
    if (keys === undefined) {
      keys = [this.periodIntervalOne, this.periodIntervalTwo]
    }
    let options = []
    for(let key in keys) {
      key = keys[key]
      options.push(
          {
            value: key,
            label: this.periodIntervalLabel(key)
          }
      )
    }
    return options
  },
  periodLabel(period) {
    switch(period) {
      case this.periodMonth:
        return Core.Definition.getDefinition('Mois');
        break
      case this.periodWeek:
        return Core.Definition.getDefinition('Semaines');
        break
      case this.periodDay:
        return Core.Definition.getDefinition('Jours');
        break
      case this.periodYear:
        return Core.Definition.getDefinition('Années');
        break
      case this.periodNever:
        return Core.Definition.getDefinition('Jamais');
        break
      default:
        return ''
        break
    }
  },
  periodOptions(keys) {
    if (keys === undefined) {
      keys = [this.periodMonth, this.periodWeek, this.periodDay, this.periodYear]
    }
    let options = []
    for(let key in keys) {
      key = keys[key]
      options.push(
          {
            value: key,
            label: this.periodLabel(key)
          }
      )
    }
    return options
  },
  typeLabel(type) {
    switch(type) {
      case this.typeStandard:
        return Core.Definition.getDefinition('Standard');
        break
      case this.typeOrder:
        return Core.Definition.getDefinition('Commande');
        break
      case this.typeRecurringSubscription:
        return Core.Definition.getDefinition('Abon. récurrent');
        break
      case this.typeLimitedSubscription:
        return Core.Definition.getDefinition('Abon. limité');
        break
      case this.typeVariableStandard:
        return Core.Definition.getDefinition('Standard Variable');
        break
      case this.typeVariableRecurringSubscription:
        return Core.Definition.getDefinition('Abon. récurrent Variable');
        break
      case this.typeVariableLimitedSubscription:
        return Core.Definition.getDefinition('Abon. limité Variable');
        break
      default:
        return ''
        break
    }
  },
  typeOptions(keys) {
    if (keys === undefined) {
      keys = [this.typeStandard, this.typeRecurringSubscription, this.typeLimitedSubscription, this.typeVariableStandard, this.typeVariableRecurringSubscription, this.typeVariableLimitedSubscription]
    }
    let options = []
    for(let key in keys) {
      key = keys[key]
      options.push(
          {
            value: key,
            label: this.typeLabel(key)
          }
      )
    }
    return options
  },
  displayImage(image) {
    if (image !== '' && image != null) {
      if (!Array.isArray(image)) {
        image = JSON.parse(image)
      }
      if (image[0] !== undefined && image[0].src !== undefined) {
        return image[0].src
      }
    }
    return Mantle.Config.api.url + Mantle.Config.defaultProductImgUrl
  },
  conditionalIsEnabled(product) {
    if (Core.Value.encode(product.conditionalIsEnabled, Core.Value.typeCheckbox)) {
      return true
    }
    return false
  },
  participantModeIsEnabled(product) {
    if (Core.Value.encode(product.ticketIsEnabled, Core.Value.typeCheckbox) || Core.Value.encode(product.teamIsEnabled, Core.Value.typeCheckbox) || Core.Value.encode(product.participantCategoryIsEnabled, Core.Value.typeCheckbox) || Core.Value.encode(product.tshirtSizeIsEnabled, Core.Value.typeCheckbox)) {
      return true
    }
    return false
  },
  ticketIsEnabled(product) {
    if (Core.Value.encode(product.ticketIsEnabled, Core.Value.typeCheckbox)) {
      return true
    }
    return false
  },
  teamIsEnabled(product) {
    if (Core.Value.encode(product.teamIsEnabled, Core.Value.typeCheckbox)) {
      return true
    }
    return false
  },
  participantCategoryIsEnabled(product) {
    if (Core.Value.encode(product.participantCategoryIsEnabled, Core.Value.typeCheckbox)) {
      return true
    }
    return false
  },
  tshirtSizeIsEnabled(product) {
    if (Core.Value.encode(product.tshirtSizeIsEnabled, Core.Value.typeCheckbox)) {
      return true
    }
    return false
  },
  hasForm(product) {
    if (product.form !== undefined && product.form.id !== undefined) {
      if (Core.Validation.isId(product.form.id)) {
        return true
      }
    }
    return false
  }
}
